import { render, staticRenderFns } from "./HasAnswered.vue?vue&type=template&id=ef4db6d8&"
import script from "./HasAnswered.vue?vue&type=script&lang=ts&"
export * from "./HasAnswered.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports